import React from "react";
import Split from "react-split";

interface DispatchWorkspaceProps {
  sections: string[];
  sizes: number[];
  onSplitResize: (sizes: number[]) => void;
  mapPanel: React.ReactNode;
  schedulerPanel: React.ReactNode;
  queuePanel: React.ReactNode;
}

const DispatchWorkspace: React.FC<DispatchWorkspaceProps> = ({
  sections,
  sizes,
  onSplitResize,
  mapPanel,
  schedulerPanel,
  queuePanel,
}) => {
  const renderSection = (section: string) => {
    if (section === "map") {
      return (
        <div
          key="map"
          style={{ height: "100%", overflow: "hidden" }}
          className="bg-white border-b border-gray-200"
        >
          {mapPanel}
        </div>
      );
    }

    if (section === "scheduler") {
      return (
        <div key="scheduler" style={{ height: "100%", overflow: "hidden" }}>
          {schedulerPanel}
        </div>
      );
    }

    if (section === "dispatchLayout") {
      return (
        <div key="dispatchLayout" style={{ height: "100%", overflow: "hidden" }}>
          {queuePanel}
        </div>
      );
    }

    return null;
  };

  if (sections.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-500">
        <p>All sections are hidden. Use the toggle buttons to show sections.</p>
      </div>
    );
  }

  if (sections.length === 1) {
    return <>{renderSection(sections[0])}</>;
  }

  return (
    <Split
      key={`split-${sections.join("-")}`}
      className="flex h-full split"
      sizes={sizes}
      minSize={0}
      expandToMin={false}
      gutterSize={10}
      gutterAlign="center"
      snapOffset={30}
      dragInterval={1}
      direction="vertical"
      cursor="row-resize"
      onDragEnd={onSplitResize}
    >
      {sections.map(renderSection)}
    </Split>
  );
};

export default DispatchWorkspace;
